import * as React from "react";
import Parallax from "./ParallaxHero";
import { Container, Row, Col } from "react-bootstrap";
import SubHeading from "./typography/SubHeading";
import Button from "./GibsonButton";
import styled from "styled-components";
import Theme from "../../vars/ThemeOptions";
import { colors } from "../../vars/palette";
import { RichText, RichTextReact } from "wmk-rich-text";
import { Img } from "wmk-image";
import ReactMarkdown from "react-markdown";
import { options } from "../blocks/RichText/richTextOptions";

const ContentWrap = styled.div`
  position: relative;
  z-index: 10;

  .has-line {
    position: relative;
    top: 6rem;
    z-index: 2;
    & > .row {
      border-left: 4px solid ${colors.hex("secondary")};
      padding-bottom: 8rem;
    }
  }
  .ani-button {
    max-width: 200px;
    text-align: center;
    font-family: ${Theme.font.head};
  }
  .flex-column .col {
    padding: 2rem;
  }
`;

type ParallaxContentProps = {
  title: string;
  content?: string;
  Component?: React.FunctionComponent;
  richText?: RichText;
  button: { to?: string; type?: string; text?: string; show?: boolean };
  image?: Img;
};

const ParallaxContent = ({
  title,
  content,
  richText,
  button,
  image,
  Component,
}: ParallaxContentProps) => {
  return (
    <ContentWrap>
      <Container className="has-line">
        <Row className="flex-column">
          <Col>
            <SubHeading text={title} />
            {richText ? (
              <RichTextReact content={richText} options={options} />
            ) : content ? (
              <ReactMarkdown>{content}</ReactMarkdown>
            ) : (
              <Component />
            )}
            {button && button.show && (
              <div className="ani-button">
                <Button to={button.to} direction="right">
                  {button.text}
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </Container>
      <Parallax image={image} />
    </ContentWrap>
  );
};

export default ParallaxContent;
